export default "__VITE_ASSET__BZvn86Pj__"